import {DEFAULT_PAGE_NUMBER, ORDER, SORT_FIELDS as COMMON_SORT_FIELDS} from '../base.js'

export const HAS_VEHICLE_INFO_COMPETITORS = false

export const HAS_MODEL_PAGE = true

export const TECHNICAL_DETAILS_SEARCH_URL = '/fichas_tecnicas/buscador.aspx'

export const TECHNICAL_DETAILS_EMPTY_VEHICLE_IMAGE = 'images/no-photo.png'

export const TECHNICAL_DETAILS_DEFAULT_VEHICLE_ID = 0

export const TECHNICAL_DETAILS_VERSIONS_TABLE_CONFIG = 'YEAR_VERSION_FUEL_POWER'

export const DEFAULT_SEARCH = {
  page: DEFAULT_PAGE_NUMBER,
  sortBy: COMMON_SORT_FIELDS.TITLE,
  sortOrder: ORDER.ASC
}

export const TECHNICAL_DETAILS_COMPARATOR_SPECIFICATIONS_FIELDS = {
  make: {
    fieldLabel: 'COMMON.MAKE'
  },
  model: {
    fieldLabel: 'COMMON.PLURALS.MODEL'
  },
  bodyType: {
    fieldLabel: 'COMMON.PLURALS.BODY_TYPE'
  },
  version: {
    fieldLabel: 'COMMON.VERSION'
  },
  price: {
    fieldLabel: 'COMMON.PRICE',
    type: 'currency',
    highlightType: 'saving'
  },
  consumptionAverage: {
    fieldLabel: 'TECHNICAL_DETAILS_CONSUMPTION_AVERAGE_MODEL_DETAILS',
    valueLabel: 'TECHNICAL_DETAILS_CONSUMPTION_VALUE_MODEL_DETAILS',
    params: {
      consumption: 'consumptionAverage'
    },
    highlightType: 'saving'
  },
  consumptionAverageElectricWltp: {
    fieldLabel: 'TECHNICAL_DETAILS_CONSUMPTION_AVERAGE_ELECTRIC_WLTP',
    valueLabel: 'TECHNICAL_DETAILS_CONSUMPTION_VALUE_ELECTRIC_WLTP',
    params: {
      consumption: 'consumptionAverageElectricWltp'
    },
    highlightType: 'saving'
  },
  fuelType: {
    fieldLabel: 'COMMON.FUEL'
  },
  hp: {
    fieldLabel: 'COMMON_POWER',
    valueLabel: 'TECHNICAL_DETAILS_HP_VALUE_MODEL_DETAILS',
    highlightType: 'feature',
    params: {
      hp: 'hp'
    }
  },
  cubicCapacity: {
    fieldLabel: 'COMMON_LITRES',
    valueLabel: 'TECHNICAL_DETAILS_CUBIC_CAPACITY_VALUE_MODEL_DETAILS',
    params: {
      cubicCapacity: 'cubicCapacity'
    }
  },
  acceleration: {
    fieldLabel: 'TECHNICAL_DETAILS_ACCELERATION_MODEL_DETAILS',
    valueLabel: 'TECHNICAL_DETAILS_ACCELERATION_VALUE_MODEL_DETAILS',
    highlightType: 'feature',
    params: {
      acceleration: 'acceleration'
    }
  },
  topSpeed: {
    fieldLabel: 'TECHNICAL_DETAILS_TOP_SPEED_MODEL_DETAILS',
    valueLabel: 'TECHNICAL_DETAILS_TOP_SPEED_VALUE_MODEL_DETAILS',
    highlightType: 'feature',
    params: {
      topSpeed: 'topSpeed'
    }
  },
  consumptionUrban: {
    fieldLabel: 'TECHNICAL_DETAILS_CONSUMPTION_URBAN_MODEL_DETAILS',
    valueLabel: 'TECHNICAL_DETAILS_CONSUMPTION_VALUE_MODEL_DETAILS',
    params: {
      consumption: 'consumptionUrban'
    }
  },
  consumptionExtraUrban: {
    fieldLabel: 'TECHNICAL_DETAILS_CONSUMPTION_EXTRA_URBAN_MODEL_DETAILS',
    valueLabel: 'TECHNICAL_DETAILS_CONSUMPTION_VALUE_MODEL_DETAILS',
    params: {
      consumption: 'consumptionExtraUrban'
    }
  },
  traction: {
    fieldLabel: 'TECHNICAL_DETAILS_TRACTION_MODEL_DETAILS'
  },
  emissions: {
    fieldLabel: 'TECHNICAL_DETAILS_EMISSIONS_MODEL_DETAILS',
    valueLabel: 'TECHNICAL_DETAILS_EMISSIONS_VALUE_MODEL_DETAILS',
    highlightType: 'saving',
    params: {
      emissions: 'emissions'
    }
  },
  dimensions: {
    fieldLabel: 'TECHNICAL_DETAILS_DIMENSIONS_MODEL_DETAILS',
    valueLabel: 'TECHNICAL_DETAILS_DIMENSIONS_VALUE_MODEL_DETAILS',
    params: {
      width: 'width',
      height: 'height',
      length: 'length'
    }
  },
  weight: {
    fieldLabel: 'TECHNICAL_DETAILS_WEIGHT_MODEL_DETAILS',
    valueLabel: 'TECHNICAL_DETAILS_WEIGHT_VALUE_MODEL_DETAILS',
    params: {
      weight: 'weight'
    }
  },
  luggageCapacity: {
    fieldLabel: 'TECHNICAL_DETAILS_LUGGAGE_CAPACITY_MODEL_DETAILS',
    valueLabel: 'TECHNICAL_DETAILS_LUGGAGE_CAPACITY_VALUE_MODEL_DETAILS',
    params: {
      luggageCapacity: 'luggageCapacity'
    }
  },
  seats: {
    fieldLabel: 'TECHNICAL_DETAILS_SEATS_MODEL_DETAILS'
  }
}
